import React, {Component, useEffect, useState} from 'react';
import { connect } from 'react-redux';

import Button from "../../ui/components/buttons/button";

import {withRouter} from "react-router-dom";
import TitleBox from "../title-box";

import "./application-confirm.css";
import {_getSite, _getStep, _setStep, _showModal} from "../../store/system/service";
import {_getPolicy, _storePolicy} from "../../store/policy/service";
import Template from "../template";
import {useTranslation} from "react-i18next";
import {_formatAmount, _gaPushEvent, _gaPushData} from "../../utils/utility"
import EditMode from "../../assets/EditMode.svg";
import LabelledCheckbox from "../../ui/components/form-controls/labelled-checkbox";
import Checkbox from "../../ui/components/form-controls/checkbox";
import PolicyWording from '../../assets/pdf/BIZ_Policy Wording_COMBINED_141220.pdf';
import ModalExclusions from '../modal-exclusions';
import ModalDeclarations from "../modal-declarations";


const ApplicationConfirm = (props) => {
    const { t, i18n } = useTranslation();
    const premiseOwnershipTypeOptions = [
        {
            label: 'Rent',
            value: 'rent'
        },
        {
            label: 'Own',
            value: 'own'
        }
    ]

    const annualTurnoverOptions = [
        {
            "text": "Up to $1,000,000",
            "value": "1"
        },
        {
            "text": "$1,000,001 to $2,000,000",
            "value": "2"
        },
        {
            "text": "$2,000,001 to $3,000,000",
            "value": "3"
        },
        {
            "text": "$3,000,001 to $4,000,000",
            "value": "4"
        },
        {
            "text": "$4,000,001 to $5,000,000",
            "value": "5"
        },
        {
            "text": "$5,000,001 to $6,000,000",
            "value": "6"
        },
        {
            "text": "$6,000,001 to $7,000,000",
            "value": "7"
        },
        {
            "text": "$7,000,001 to $8,000,000",
            "value": "8"
        },
        {
            "text": "$8,000,001 to $9,000,000",
            "value": "9"
        },
        {
            "text": "$9,000,001 to $11,000,000",
            "value": "10"
        },
        {
            "text": "$11,000,001 to $13,000,000",
            "value": "11"
        },
        {
            "text": "$13,000,001 to $15,000,000",
            "value": "12"
        },
        {
            "text": "$15,000,001 to $17,000,000",
            "value": "13"
        },
        {
            "text": "$17,000,001 to $19,000,000",
            "value": "14"
        },
        {
            "text": "$19,000,001 to $20,000,000",
            "value": "15"
        }
    ]

    const getOwnershipType = (type) => {
        let ownershipTypes = premiseOwnershipTypeOptions.filter((item) => item.value === type);
        if (ownershipTypes.length > 0) {
            return ownershipTypes[0].label;
        }
        return '';
    }

    const getAnnualTurnoverOption = (option) => {
        let options = annualTurnoverOptions.filter((item) => item.value === option);
        if (options.length > 0) {
            return options[0].text;
        }
        return '';
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        // Google Analytics
        _gaPushData({
            'pageStep': 'Apply – Summary',
            'vPath': '/apply-Summary',
            'event': 'vpageview'
        });
    }, [])

    const [exclusions, setExclusions] = useState(false);
    const [declarations, setDeclarations] = useState(false);
    const [confirmation, setConfirmation] = useState({
        agreement1: false,
        agreement2: false
    });

    const gotoProductPage = () => {
        _gaPushEvent('editProductSelection');
        props.history.push((props.site ? '/' + props.site : '') + '/quote/product');
    }

    const gotoSizePage = () => {
        _gaPushEvent('editBusinessSize');
        props.history.push((props.site ? '/' + props.site : '') + '/quote/review');
    }

    const gotoUenPage = () => {
        _gaPushEvent('editInsuredBusinessInformation');
        props.history.push((props.site ? '/' + props.site : '') + '/application/uen');
    }

    const gotoApplicationPage = (src) => {
        if (src === 'contact'){
            _gaPushEvent('editContactInformation');
        } else if (src === 'ip'){
            _gaPushEvent('editInterestedParty');
        }

        props.history.push((props.site ? '/' + props.site : '') + '/application');
    }


    const continueNextPage = () => {
        if(confirmation.agreement1){
            _gaPushEvent('ConfirmApply');
            if(confirmation.agreement2){
                props.policy.policySME.applicant.directMarketing = true;
                props.storePolicy(props.policy);
            }
            props.history.push((props.site ? '/' + props.site : '') + '/payment');
        }
    }
    const getSiteWording = ()=>{
        switch (props.site){
            case 'bm':
                return 'Brian Mae'
            case 'mla':
                return <>Multi-Lines Agencies</>
            default:
                return 'g&m'
        }
    }
    return (
        <Template simple="We Insure You" leftNav step={props.step} policy={props.policy} site={props.site} prevPage="/application">
                <div className="ApplicationConfirmPaddingStyle">


                <TitleBox mt="24px" mb="24px" lh="25px">
                    Product Selection
                    <img className="ApplicationConfirmEditModeStyle"
                         src={EditMode}
                        onClick={gotoProductPage}/>
                </TitleBox>

                <div className="ApplicationConfirmInputGroupsStyle">
                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Business Type
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.businessType}
                        </div>
                    </div>
                </div>

                <TitleBox mt="24px" mb="24px" lh="25px">
                    Business Size
                    <img className="ApplicationConfirmEditModeStyle"
                         src={EditMode}
                         onClick={gotoSizePage}/>
                </TitleBox>

                <div className="ApplicationConfirmInputGroupsStyle">
                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Estimated Annual Turnover/Revenue
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {getAnnualTurnoverOption(props.policy.policySME.situationTurnoverCode)}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            No. of Employee(s)
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            { props.policy.policySME.numberOfEmployees }
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Estimated Annual Salaries
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            { _formatAmount(props.policy.policySME.annualWages, i18n.language, t("currency.prefix")) }
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Physical Assets Value
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            { _formatAmount(props.policy.policySME.contentsSI, i18n.language, t("currency.prefix")) }
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Premise Ownership Type
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {getOwnershipType(props.policy.policySME.ownershipType)}
                        </div>
                    </div>

                    {
                        props.policy.policySME.ownershipType === 'own' &&
                        <div className="ApplicationConfirmInputGroupWideStyle">
                            <div className="ApplicationConfirmInputLabelStyle">
                                Premise Value
                            </div>
                            <div className="ApplicationConfirmInputBoxStyle">
                                {_formatAmount(props.policy.policySME.buildingSI, i18n.language, t("currency.prefix"))}
                            </div>
                        </div>
                    }
                </div>

                <TitleBox mt="24px" mb="24px" lh="25px">
                    Insured Business Information
                    <img className="ApplicationConfirmEditModeStyle"
                         src={EditMode}
                         onClick={gotoUenPage}/>
                </TitleBox>

                <div className="ApplicationConfirmInputGroupsStyle">
                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Period of Insurance
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.inceptionDate} - {props.policy.policySME.expiryDate}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            UEN Number
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.applicant.uen}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Company Name
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.applicant.fullName}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Business Description
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.occupationDesc}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Insured Business Address
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.locationUnitNo} <br/>
                            {props.policy.policySME.locationAddress1} <br/>
                            {props.policy.policySME.locationPostCode}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Personal Accident Insured Person
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.insuredPerson}
                        </div>
                    </div>

                    <div className="ApplicationConfirmInputGroupWideStyle">
                        <div className="ApplicationConfirmInputLabelStyle">
                            Date of Birth
                        </div>
                        <div className="ApplicationConfirmInputBoxStyle">
                            {props.policy.policySME.insuredPersonBirthDate}
                        </div>
                    </div>

                </div>

            <TitleBox mt="24px" mb="24px" lh="25px">
                Contact Information
                <img className="ApplicationConfirmEditModeStyle"
                     src={EditMode}
                     onClick={() => {gotoApplicationPage("contact")}}/>
            </TitleBox>

            <div className="ApplicationConfirmInputGroupsStyle">
                <div className="ApplicationConfirmInputGroupWideStyle">
                    <div className="ApplicationConfirmInputLabelStyle">
                        Name of Insured
                    </div>
                    <div className="ApplicationConfirmInputBoxStyle">
                        {props.policy.policySME.applicant.forAttentionOf}
                    </div>
                </div>

                <div className="ApplicationConfirmInputGroupWideStyle">
                    <div className="ApplicationConfirmInputLabelStyle">
                        Mobile Number
                    </div>
                    <div className="ApplicationConfirmInputBoxStyle">
                        {props.policy.policySME.applicant.mobileNo}
                    </div>
                </div>

                <div className="ApplicationConfirmInputGroupWideStyle">
                    <div className="ApplicationConfirmInputLabelStyle">
                        Email Address
                    </div>
                    <div className="ApplicationConfirmInputBoxStyle">
                        {props.policy.policySME.applicant.email}
                    </div>
                </div>

                <div className="ApplicationConfirmInputGroupWideStyle">
                    <div className="ApplicationConfirmInputLabelStyle">
                        Corresponding Address
                    </div>
                    <div className="ApplicationConfirmInputBoxStyle">
                        {props.policy.policySME.applicant.applicantUnitNo} <br/>
                        {props.policy.policySME.applicant.applicantAddress1} <br/>
                        {props.policy.policySME.applicant.applicantPostCode}
                    </div>
                </div>
            </div>

            {
                props.policy.policySME.applicant.hasInterestedParty == 'true' &&
                <React.Fragment>
                    <TitleBox mt="24px" mb="24px" lh="25px">
                        Interested Party
                        <img className="ApplicationConfirmEditModeStyle"
                             src={EditMode}
                             onClick={() => {gotoApplicationPage("ip")}}/>
                    </TitleBox>

                    <div className="ApplicationConfirmInputGroupsStyle">
                        <div className="ApplicationConfirmInputGroupWideStyle">
                            <div className="ApplicationConfirmInputLabelStyle">
                                Company Name/Full Name
                            </div>
                            <div className="ApplicationConfirmInputBoxStyle">
                                {props.policy.policySME.interestedParty.corporateName}
                            </div>
                        </div>

                        <div className="ApplicationConfirmInputGroupWideStyle">
                            <div className="ApplicationConfirmInputLabelStyle">
                                Role
                            </div>
                            <div className="ApplicationConfirmInputBoxStyle">
                                {props.policy.policySME.interestedParty.role}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            }
            <div className="ApplicationConfirmCheckboxGroupsStyle">
                <div className="ApplicationConfirmCheckboxGroupWideStyle">
                    <div className="ApplicationConfirmCheckboxStyle">
                        <Checkbox 
                            onClick={(event) => {
                                setConfirmation({
                                    ...confirmation,
                                    agreement1: event.target.checked
                                })
                            }}
                        />
                    </div>
                    <div className="ApplicationConfirmCheckBoxLabelStyle">
                            I/we have read, understood and accepted: <br/>
                            <li><a href={PolicyWording} onClick={() => {_gaPushEvent('viewpolicy')}} target="_blank">Policy</a></li>
                            <li><a href="#" onClick={() => {setExclusions(true); _gaPushEvent('viewexclusion')}}>Exclusions</a> </li>
                            <li><a href="https://www.qbe.com/sg/privacy-policy" onClick={() => {_gaPushEvent('viewprivacy')}} target="_blank">QBE Privacy Policy</a></li>
                            <li><a href="#" onClick={() => {setDeclarations(true);}}>Declarations</a> </li>
                    </div>
                </div>
                <div className="ApplicationConfirmCheckboxGroupWideStyle">
                    <div className="ApplicationConfirmCheckboxStyle">
                        <Checkbox 
                            onClick={(event) => {
                                setConfirmation({
                                    ...confirmation,
                                    agreement2: event.target.checked
                                })
                            }}
                        />
                    </div>
                    <div className={'ApplicationConfirmCheckBoxLabelStyle '+(props.site==='mla'?'MLA':'')}>
                        I/we agree QBE to transfer my/our personal data <br/>
                        to {getSiteWording()} for the purpose of receiving market offers <br/>
                        and promotions as prescribed in the PDPA.
                    </div>
                </div>
            </div>
            <ModalExclusions showModal={exclusions} hideModal={() => {setExclusions(false)}}/>
            <ModalDeclarations showModal={declarations} hideModal={() => {setDeclarations(false)}}/>
            <div className="ApplicationConfirmInputButtonsGroupStyle">
                <div className="ApplicationConfirmInputButtonsStyle">
                    <Button color="primary" onClick={continueNextPage} disabled={!confirmation.agreement1}>Continue</Button>
                </div>
            </div>
                </div>
        </Template>
    );
}

// get status from redux (subscription)
const mapStateToProps = (state) => {
    return {
        step: _getStep(state),
        policy: _getPolicy(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    setStep: _setStep,
    showModal: _showModal,
    storePolicy: _storePolicy
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApplicationConfirm));
